import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import moment from "moment";
import PropTypes from "prop-types";


import {setJobPaymentRefundTransactionId} from "./jobPaymentActions";
import SvgIcons from "../../Icons/SvgIcons";
import {transactionInterface} from "./JobPaymentInterfaces";
import {TRANSACTION_STATUSES} from "./jobPaymentReducer";

const JobPaymentPopupTransaction = (props) => {

  const {transaction, setJobPaymentRefundTransactionId} = props;

  const momentTime = moment(transaction.created);

  const isError = transaction.status === TRANSACTION_STATUSES.Refunded
    || transaction.status === TRANSACTION_STATUSES.Error
    || transaction.status === TRANSACTION_STATUSES.Failed;

  const transactionColor = transaction.status === TRANSACTION_STATUSES.Success
    ? "color-green"
    : isError
      ? "color-red2"
      : "";

  return (
    <li className="job-payment__transaction job-payment__text flex margin-b8 color-gray4">
      <div className="job-payment__transaction-cell job-payment__transaction-cell--time">
        {momentTime.format('MM/DD/YY')} {momentTime.format('HH:mm')}
      </div>
      <div className="job-payment__transaction-cell job-payment__transaction-cell--amount">
        ${transaction.amount}
      </div>
      <div className="job-payment__transaction-cell job-payment__transaction-cell--type">
        {transaction.paymentType}
      </div>
      <div className={"job-payment__transaction-cell job-payment__transaction-cell--status " + transactionColor}>
        {transaction.status}
      </div>
      <div className="job-payment__transaction-cell job-payment__transaction-cell--button">
        <span className={"link link--black link--refund bold transition"
          + (isError ? " link--disabled opacity-25" : "")}
              onClick={isError ? null : setJobPaymentRefundTransactionId(transaction.transactionId)}>
          <span className="link-icon">{SvgIcons.refundIcon}</span>
          <FormattedMessage id="paymentPopup.refund.button"/>
        </span>
      </div>
    </li>
  )
};

JobPaymentPopupTransaction.propTypes = {
  transaction: PropTypes.shape(transactionInterface).isRequired,
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  setJobPaymentRefundTransactionId,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupTransaction)
)
